function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError('Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o)
        return;
    if (typeof o === 'string')
        return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === 'Object' && o.constructor)
        n = o.constructor.name;
    if (n === 'Map' || n === 'Set')
        return Array.from(o);
    if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null || iter['@@iterator'] != null)
        return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr))
        return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length)
        len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
        arr2[i] = arr[i];
    }
    return arr2;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
import utils from './utils';
var HighEnergy = function () {
    function HighEnergy(player) {
        _classCallCheck(this, HighEnergy);
        this.player = player;
        this.video = player.video;
        this.container = this.player.template.highEnergyBar;
        this.option = {};
        this.slice = 100;
        this.Xdata = utils.createArray(this.slice).map(function (el, index) {
            return index + '';
        });
        this.Ydata = utils.createArray(this.slice).map(function () {
            return 0;
        });
        this.isShow = player.options.danmaku.showHighEnergy;
        if (window.echarts)
            this.init();
        else
            player.notice('Error: Can\'t find Echarts');
    }
    _createClass(HighEnergy, [
        {
            key: 'getData',
            value: function getData() {
                var _this = this;
                this.danmaku = this.player.danmaku.dan;
                var danSlice = this.video.duration / this.slice;
                this.Xdata.forEach(function (el, index) {
                    _this.danmaku.forEach(function (dan) {
                        if (index * danSlice < +dan.time && +dan.time < (index + 1) * danSlice) {
                            _this.Ydata[index]++;
                        }
                    });
                });
                var max = Math.max.apply(Math, _toConsumableArray(this.Ydata));
                var min = Math.min.apply(Math, _toConsumableArray(this.Ydata));
                var thorn = (max - min) / 5;
                console.log('单位弹幕量极值分别为\uFF1A', max, min);
                this.Ydata.forEach(function (el, index) {
                    _this.Ydata[index] = Math.max(thorn, el);
                    if (Math.abs(_this.Ydata[index + 1] - el) <= thorn && index !== _this.Ydata.length - 1) {
                        _this.Ydata[index + 1] = parseInt((el + _this.Ydata[index + 1]) / 2);
                    }
                });
                console.log(this.Ydata);
            }
        },
        {
            key: 'init',
            value: function init() {
                var _this$player$template;
                this.getData();
                var themeColor = (_this$player$template = this.player.template) === null || _this$player$template === void 0 ? void 0 : _this$player$template.container.style.getPropertyValue('--themeColor');
                console.log(utils.hex2Rgb(themeColor, 0.4));
                if (!this.highEnergyBar) {
                    this.highEnergyBar = window.echarts.init(this.container);
                }
                this.option = {
                    grid: {
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0
                    },
                    visualMap: {
                        type: 'piecewise',
                        show: false,
                        dimension: 0,
                        seriesIndex: 0,
                        pieces: [
                            {
                                gt: 0,
                                lt: 0,
                                color: utils.hex2Rgb(themeColor, 0.4)
                            },
                            {
                                gt: 0,
                                lt: this.slice - 1,
                                color: 'rgba(245, 245, 245, 0.4)'
                            }
                        ]
                    },
                    xAxis: [{
                            type: 'category',
                            boundaryGap: false,
                            data: this.Xdata,
                            show: false
                        }],
                    yAxis: [{
                            show: false,
                            type: 'value'
                        }],
                    series: [{
                            type: 'line',
                            smooth: 0.4,
                            lineStyle: { width: 0 },
                            showSymbol: false,
                            areaStyle: {},
                            emphasis: { focus: 'series' },
                            data: this.Ydata
                        }]
                };
                this.highEnergyBar.setOption(this.option);
            }
        },
        {
            key: 'show',
            value: function show() {
                this.container.classList.add('show');
                this.resize();
                this.isShow = true;
            }
        },
        {
            key: 'hide',
            value: function hide() {
                this.container.classList.remove('show');
                this.isShow = false;
            }
        },
        {
            key: 'update',
            value: function update(rate) {
                if (isNaN(rate))
                    return;
                var percent = Math.floor(rate * this.slice);
                this.option.visualMap.pieces[0].lt = Math.min(percent, this.slice - 1);
                this.option.visualMap.pieces[1].gt = Math.min(percent, this.slice - 1);
                this.highEnergyBar.setOption(this.option);
                this.resize();
            }
        },
        {
            key: 'reload',
            value: function reload(rate) {
                this.Ydata = utils.createArray(this.slice).map(function () {
                    return 0;
                });
                this.init();
                rate && this.update(rate);
                this.resize();
            }
        },
        {
            key: 'resize',
            value: function resize() {
                this.highEnergyBar.resize();
            }
        }
    ]);
    return HighEnergy;
}();
export {
    HighEnergy as default
};